module.exports = __webpack_public_path__ + "static/media/richer.dd40324b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/richer.png
// module id = 316
// module chunks = 6